module.exports = __webpack_public_path__ + "img/main_logo.de47d0da.png";